export const APPROVE_DECLINE_MODAL = {
  TRANSACTIONS_TEXT: 'transactions',
  GROSS_SALE_TEXT: 'gross sales',
  CAD_TEXT: 'cad $',
  NET_SALES_TEXT: 'net sales',
};
